var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncomeGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9066_19071",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 0H0V62H62V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9066_19071)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9066_19071",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 0H0V62H62V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9066_19071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1249 40.8958C30.1249 39.4005 26.0158 37.2973 19.3417 37.2973C12.6676 37.2973 8.55859 39.3883 8.55859 40.8958C8.55859 42.4032 12.6676 44.4942 19.3417 44.4942C26.0158 44.4942 30.1249 42.4032 30.1249 40.8958ZM8.55859 46.2812C8.55859 47.7765 12.6676 49.8797 19.3417 49.8797C26.0158 49.8797 30.1249 47.7887 30.1249 46.2812V43.7648C27.7787 45.4059 23.4751 46.2812 19.3417 46.2812C15.2084 46.2812 10.9049 45.4059 8.55859 43.7648V46.2812ZM8.55859 51.6789C8.55859 53.1742 12.6676 55.2773 19.3417 55.2773C26.0158 55.2773 30.1249 53.1864 30.1249 51.6789V49.1624C27.7787 50.8036 23.4751 51.6789 19.3417 51.6789C15.2084 51.6789 10.9049 50.8036 8.55859 49.1624V51.6789ZM36.6653 18.1867L40.8959 22.4052L48.7249 14.5883C49.0775 14.2358 49.0775 13.6644 48.7249 13.3118C48.3724 12.9593 47.801 12.9593 47.4485 13.3118L40.8959 19.8644L37.9418 16.8981C37.5892 16.5455 37.0178 16.5455 36.6653 16.8981C36.3127 17.2506 36.3127 17.822 36.6653 18.1746V18.1867ZM31.912 17.5424C31.912 11.5977 36.7504 6.75928 42.6951 6.75928C48.6398 6.75928 53.4782 11.5977 53.4782 17.5424C53.4782 23.4871 48.6398 28.3255 42.6951 28.3255C36.7504 28.3255 31.912 23.4871 31.912 17.5424ZM42.6951 33.7111C49.3692 33.7111 53.4782 31.6201 53.4782 30.1126C53.4782 29.3102 52.299 28.3377 50.1959 27.6205C48.1049 29.1887 45.5155 30.1126 42.7073 30.1126C39.899 30.1126 37.3096 29.1765 35.2186 27.6205C33.1033 28.3499 31.9363 29.3224 31.9363 30.1126C31.9363 31.6079 36.0453 33.7111 42.7194 33.7111H42.6951ZM31.912 35.5103C31.912 37.0055 36.021 39.1087 42.6951 39.1087C49.3692 39.1087 53.4782 37.0177 53.4782 35.5103V32.9938C51.1319 34.635 46.8284 35.5103 42.6951 35.5103C38.5618 35.5103 34.2582 34.635 31.912 32.9938V35.5103ZM31.912 40.8958C31.912 42.3911 36.021 44.4942 42.6951 44.4942C49.3692 44.4942 53.4782 42.4032 53.4782 40.8958V38.3793C51.1319 40.0205 46.8284 40.8958 42.6951 40.8958C38.5618 40.8958 34.2582 40.0205 31.912 38.3793V40.8958ZM31.912 46.2812C31.912 47.7765 36.021 49.8797 42.6951 49.8797C49.3692 49.8797 53.4782 47.7887 53.4782 46.2812V43.7648C51.1319 45.4059 46.8284 46.2812 42.6951 46.2812C38.5618 46.2812 34.2582 45.4059 31.912 43.7648V46.2812ZM31.912 49.1624C34.2582 50.8036 38.5618 51.6789 42.6951 51.6789C46.8284 51.6789 51.1319 50.8036 53.4782 49.1624V51.6789C53.4782 53.1742 49.3692 55.2773 42.6951 55.2773C36.021 55.2773 31.912 53.1864 31.912 51.6789V49.1624Z",
    fill: "#00625F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomeGreen);
export default __webpack_public_path__ + "static/media/income_green.4d2e08e34a65fa8aea74fe10a7fb0600.svg";
export { ForwardRef as ReactComponent };